import React from "react";
import { useNavigate } from "react-router-dom";
export default function PrivacyPolicy() {
  const pageWrapperStyle = {
    minHeight: "100vh",
    padding: "7rem 0.75rem",
    backgroundColor: "#f9fafb", // Light background
    fontFamily: "'Inter', sans-serif",
  };

  const cardStyle = {
    backgroundColor: "#ffffff",
    maxWidth: "1024px",
    margin: "0 auto",
    padding: "2.5rem",
    borderRadius: "1rem",
    boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25), 0 0 10px rgba(0, 0, 0, 0.05)",
  };

  const titleStyle = {
    fontWeight: "800",
    fontSize: "2.25rem",
    textAlign: "center",
    marginBottom: "2.5rem",
    color: "#991b1b", // Deep Red/Maroon theme color
  };

  const sectionHeadingStyle = {
    fontSize: "1.5rem",
    fontWeight: "700",
    marginTop: "2rem",
    marginBottom: "1rem",
    color: "#1f2937",
    borderBottom: "2px solid #991b1b", // Accent line
    paddingBottom: "0.5rem",
  };

  const subHeadingStyle = {
    fontSize: "1.125rem", // text-lg
    fontWeight: "600",
    marginTop: "1.5rem",
    marginBottom: "0.75rem",
    color: "#1f2937",
  };

  const textStyle = {
    fontSize: "1rem",
    lineHeight: "1.625",
    color: "#4b5563",
    marginBottom: "1.5rem",
  };

  const listStyle = {
    listStyleType: 'disc',
    paddingLeft: '1.25rem',
  };

  const numberedListStyle = {
    listStyleType: 'decimal',
    paddingLeft: '1.25rem',
  };

  const listItemStyle = {
    marginBottom: '0.5rem',
  };

  const warningBoxStyle = {
    backgroundColor: "#fef2f2", // Light Red for Important Notices
    borderLeft: "4px solid #ef4444", // Red accent
    color: "#991b1b",
    padding: "1rem",
    borderRadius: "0.5rem",
    marginTop: "1rem",
  };

  const infoBoxStyle = {
    backgroundColor: "#f0fdf4", // Light Green/Info Box
    borderLeft: "4px solid #991b1b",
    color: "#991b1b",
    padding: "1rem",
    borderRadius: "0.5rem",
    marginTop: "0.75rem",
  };

  const linkStyle = {
    color: "#991b1b",
    textDecoration: "none",
    fontWeight: "600",
  };

  const buttonContainerStyle = {
    textAlign: "center",
    marginTop: "2.5rem",
  };

  const buttonStyle = {
    backgroundColor: "#991b1b",
    color: "white",
    fontWeight: "600",
    padding: "0.75rem 2rem",
    borderRadius: "9999px",
    boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
    transition: "all 0.3s ease",
    border: 'none',
    cursor: 'pointer',
  };
  const navigate = useNavigate();


  return (
    <div style={pageWrapperStyle}>
      <div style={cardStyle}>
        <h2 style={titleStyle}>
           AeliteZ Clothings Privacy Policy
        </h2>
        <p style={textStyle}>
            This Privacy Policy describes how AeliteZ clothings (“we”, “us”, or “our”) collects, uses, and discloses personal information when you visit, use our services, or make purchases from aelitez.com (the “Site”). By using our Services, you agree to the collection and use of your information as described in this policy.
        </p>
        <p style={warningBoxStyle}>
            Effective Date: November 15, 2025 
        </p>

        {/* Section 1: Information We Collect and How We Use It */}
        <div>
          <h3 style={sectionHeadingStyle}>
            1. Information We Collect and How We Use It
          </h3>
          <p style={textStyle}>
            We collect various types of personal information depending on how you interact with our Site:
          </p>

          <h4 style={subHeadingStyle}>1.1 Information You Provide Directly</h4>
          <div style={textStyle}>
            <ul style={listStyle}>
              <li style={listItemStyle}>Basic contact details (name, address, phone number, email)</li>
              <li style={listItemStyle}>Order information (billing/shipping address, payment details)</li>
              <li style={listItemStyle}>Account information (username, password)</li>
              <li style={listItemStyle}>Customer support communications</li>
            </ul>
          </div>

          <h4 style={subHeadingStyle}>1.2 Information We Collect Automatically</h4>
          <div style={textStyle}>
            <p>We use cookies and similar technologies to collect Usage Data such as:</p>
            <ul style={listStyle}>
              <li style={listItemStyle}>Device information</li>
              <li style={listItemStyle}>IP address</li>
              <li style={listItemStyle}>Browsing behavior (to improve our services and user experience)</li>
            </ul>
          </div>

          <h4 style={subHeadingStyle}>1.3 Information from Third Parties</h4>
          <p style={textStyle}>
            We may receive information from service providers like woo-commerce and payment processors to facilitate transactions and improve our services.
          </p>
        </div>

        {/* Section 2: How We Use Your Personal Information */}
        <div>
          <h3 style={sectionHeadingStyle}>
            2. How We Use Your Personal Information
          </h3>
          <div style={textStyle}>
            <ul style={listStyle}>
              <li style={listItemStyle}>Providing Products and Services: To process orders, manage accounts, and provide customer support.</li>
              <li style={listItemStyle}>Marketing and Advertising: To send promotional communications and personalize advertising.</li>
              <li style={listItemStyle}>Security and Fraud Prevention: To detect and prevent fraudulent activities.</li>
              <li style={listItemStyle}>Communication: To communicate with you about your account, orders, and inquiries.</li>
            </ul>
          </div>
        </div>

        {/* Section 3: Cookies and Disclosure */}
        <div>
          <h3 style={sectionHeadingStyle}>
            3. Cookies and Disclosure of Personal Information
          </h3>

          <h4 style={subHeadingStyle}>3.1 Cookies</h4>
          <p style={textStyle}>
            We use cookies for site functionality, analytics, and personalized advertising. By using our Site, you consent to our use of cookies as described in our Cookie Policy.
          </p>

          <h4 style={subHeadingStyle}>3.2 How We Disclose Personal Information</h4>
          <div style={textStyle}>
            <p>We may disclose your information to:</p>
            <ul style={listStyle}>
              <li style={listItemStyle}>Service providers and partners who assist in delivering our services.</li>
              <li style={listItemStyle}>Business partners for marketing purposes.</li>
              <li style={listItemStyle}>Legal authorities in compliance with applicable laws.</li>
            </ul>
          </div>
        </div>

        {/* Section 4: Other Important Details */}
        <div>
          <h3 style={sectionHeadingStyle}>
            4. Other Important Details
          </h3>

          <h4 style={subHeadingStyle}>User Generated Content</h4>
          <p style={textStyle}>
            Content you post publicly on our Site is accessible to others and may be used by third parties. We are not responsible for third-party use of publicly available information.
          </p>

          <h4 style={subHeadingStyle}>Third Party Websites and Links</h4>
          <p style={textStyle}>
            Our Site may contain links to third-party websites. We are not responsible for their privacy practices. Please review their policies before providing any personal information.
          </p>

          <h4 style={subHeadingStyle}>Children’s Data</h4>
          <p style={textStyle}>
            Our services are not intended for children under 16. If we discover we have collected personal information from a child, we will delete it promptly.
          </p>

          <h4 style={subHeadingStyle}>Security and Retention</h4>
          <p style={textStyle}>
            We implement security measures to protect your personal information but cannot guarantee absolute security. We retain your information as long as necessary for business purposes or as required by law.
          </p>
        </div>

        {/* Section 5: Your Rights and Contact */}
        <div>
          <h3 style={sectionHeadingStyle}>
            5. Your Rights, International Transfers, and Contact
          </h3>

          <h4 style={subHeadingStyle}>Your Rights and Choices</h4>
          <p style={textStyle}>
            Depending on your location, you may have rights such as access, deletion, correction, or objection to processing of your personal information. You can exercise these rights by contacting us.
          </p>

          <h4 style={subHeadingStyle}>International Users</h4>
          <p style={textStyle}>
            Your information may be transferred outside your country of residence, including to the United States. We use appropriate safeguards for international data transfers.
          </p>

          <h4 style={subHeadingStyle}>Complaints</h4>
          <p style={textStyle}>
            If you have concerns about our data practices, please contact us using the details below.
          </p>

          <h4 style={subHeadingStyle}>Contact Us</h4>
          <div style={infoBoxStyle}>
            If you have questions about our Privacy Policy or wish to exercise your rights, please contact us at:
            <br />
            <a href="mailto:support@AeliteZclothings.in" style={linkStyle}>support@aelitez.com</a>
          </div>
        </div>

        <div style={buttonContainerStyle}>
          <button
            style={buttonStyle}
            onClick={() => navigate('/')}
          >
            I Understand and Agree
          </button>
        </div>
      </div>
    </div>
  );
}